import { render, staticRenderFns } from "./UsersView.vue?vue&type=template&id=0c0739ab"
import script from "./UsersView.vue?vue&type=script&lang=js"
export * from "./UsersView.vue?vue&type=script&lang=js"
import style0 from "./UsersView.vue?vue&type=style&index=0&id=0c0739ab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports